export default {
	"menu.welcome": "欢迎",
	"menu.more-blocks": "更多区块",
	"menu.home": "首页",
	"menu.admin": "管理页",
	"menu.login": "登录",
	"menu.register": "注册",
	"menu.register.result": "注册结果",
	"menu.dashboard": "Dashboard",
	"menu.product-catalogue": "产品目录",
	"menu.dashboard.analysis": "分析页",
	"menu.dashboard.monitor": "监控页",
	"menu.dashboard.workplace": "工作台",
	"menu.exception.403": "403",
	"menu.exception.404": "404",
	"menu.exception.500": "500",
	"menu.form": "表单页",
	"menu.form.basic-form": "基础表单",
	"menu.form.step-form": "分步表单",
	"menu.form.step-form.info": "分步表单（填写转账信息）",
	"menu.form.step-form.confirm": "分步表单（确认转账信息）",
	"menu.form.step-form.result": "分步表单（完成）",
	"menu.form.advanced-form": "高级表单",
	"menu.list": "列表页",
	"menu.list.table-list": "查询表格",
	"menu.list.basic-list": "标准列表",
	"menu.list.card-list": "卡片列表",
	"menu.list.search-list": "搜索列表",
	"menu.list.search-list.articles": "搜索列表（文章）",
	"menu.list.search-list.projects": "搜索列表（项目）",
	"menu.list.search-list.applications": "搜索列表（应用）",
	"menu.page.ip-database": "IP 数据库",
	"menu.page.ip-database-adv": "IP Database (Adv Table)",
	"menu.page.ip-database-old": "IP Database (Old)",
	"menu.page.request-logs": "请求日志",
	"menu.profile": "详情页",
	"menu.profile.basic": "基础详情页",
	"menu.profile.advanced": "高级详情页",
	"menu.result": "结果页",
	"menu.result.success": "成功页",
	"menu.result.fail": "失败页",
	"menu.exception": "异常页",
	"menu.exception.not-permission": "403",
	"menu.exception.not-find": "404",
	"menu.exception.server-error": "500",
	"menu.exception.trigger": "触发错误",
	"menu.account": "个人页",
	"menu.account.center": "个人中心",
	"menu.account.settings": "个人设置",
	"menu.account.trigger": "触发报错",
	"menu.account.logout": "退出登录",
	"menu.editor": "图形编辑器",
	"menu.editor.flow": "流程编辑器",
	"menu.editor.mind": "脑图编辑器",
	"menu.editor.koni": "拓扑编辑器",

	// product catalog integration
	"menu-management.menuitem.catalog-locked": "由产品目录统管",
	"menu-management.menuitem.catalog-linked-title": "已关联产品目录",
	"menu-management.menuitem.catalog-linked-desc": "品名、编码和条码由产品目录统管。在产品目录中更新将自动同步至此。",
	"menu-management.menuitem.unbind-btn": "取消关联产品目录",
	"menu-management.menuitem.autonomous-title": "本地独立菜品",
	"menu-management.menuitem.autonomous-desc": "此菜品处于独立状态。您可以直接编辑所有属性，也可关联至产品目录以实现跨门店统一。",
	"menu-management.menuitem.bind-btn": "关联产品目录",
	"menu-management.menuitem.bind.title": "关联至产品目录？",
	"menu-management.menuitem.bind.content": "将此菜品关联至“{name}”({code})将同步其品名、编码和条码。关联后这些字段将由产品目录统管。是否继续？",
	"menu-management.menuitem.unbind.title": "取消关联产品目录？",
	"menu-management.menuitem.unbind.content": "取消关联后，此菜品将转为本地自主管理。您可以自由修改其品名、编码和条形码。",
	"menu-management.menuitem.select-catalogue-title": "选择产品目录项",
};
